import { Component } from 'react';
import bioPicture from './assets/casey-bio-pic.jpg';
import AudioPlayer from 'react-h5-audio-player';
import nascarAudio from './assets/nascar-lap.m4a';

export default class About extends Component{
	constructor(props){
		super();
		this.state = {
			about: ''
		}
	}
	componentDidMount(){
		fetch('http://caseymoir.com/about.json').then(response => response.json()).then(data => {
			this.setState({ about: data.bio });
		});
	}
	render(){
		if(this.state.about && this.state.about !== ''){
			return (
				<div className="about">
					<span className="label">NASCAR Warm-up Lap</span>
					<AudioPlayer
						autoPlay
						src={nascarAudio}
						volume={1}
						layout="horizontal"
						showJumpControls={false}
						customAdditionalControls={[]}
						customVolumeControls={[]}
					/>
					<img src="http://caseymoir.com/casey-bio-pic.jpg" alt="Casey Moir" title="Casey Moir" className="bioPic" />
					<p className="bio">{this.state.about}</p>
					<p className="contact">
						Contact: <a href="mailto:casey@caseymoir.com">Casey@CaseyMoir.com</a>
					</p>
				</div>
			);
		}else {
			return null;
		}
	}
}